import React, { createContext, useContext } from 'react';
import { BrowserJsPlumbInstance } from '@jsplumb/community';
import { WidgetType } from '@kemu-io/kemu-core/types';
import { HubSystemInfo } from '@kemu-io/hs-types';
import { NoteWidgetState } from '@kemu-io/kemu-core/widgets/note/index.js';
import { StatelessWidgetsMap } from '@src/types/core_t';

export type ShowHelpConfig = {
  widgetId: string;
  type: WidgetType;
  recipeId: string;
  thingRecipeId: string;
  isNativeWidget?: boolean;
  /** if provided, no dynamic content will be fetched and this will be used as the help content */
  customMarkdown?: string;
  customTitle?: string;
}

export type DrawingStatus = 'idle' | 'drawing' | 'drawn' | 'removing' | 'removed';
export type LogicMapperContextInstance = {
  jsPlumb: BrowserJsPlumbInstance | null;
  onShowHelp: (config: ShowHelpConfig | null) => void;
  logicMapperContainerEl: HTMLDivElement | null;
  systemInfo: HubSystemInfo | null;
  // drawPortsForWidget: (widgetId: string, widgetType: WidgetType) => void;
  // drawVirtualPorts: (widgetId: string, widgetType: WidgetType) => void;
  cleanupAllVirtualPorts: () => void;
  drawPortsAndConnections: (widgets: StatelessWidgetsMap) => void;
  removePortsAndConnections: (widgets: StatelessWidgetsMap) => void;
  toggleWidgetPortsVisibility: (config: { widgetId: string, visible: boolean, inputsOnly?: boolean, outputsOnly?: boolean }) => void;
  drawingStatus: DrawingStatus;
  setDrawingStatus: (status: DrawingStatus) => void;
  getInnerItems: (noteId: string, noteState: NoteWidgetState | null, widgetsMap: StatelessWidgetsMap) => { widgets: Array<{ id: string }>; virtualPorts: Array<{ domId: string }> };
  // drawVirtualPortsForWidgets: (widgets: StatelessWidgetsMap) => void;
}

export const LogicMapperContext = createContext<LogicMapperContextInstance>({
  jsPlumb: null,
  onShowHelp: () => {},
  logicMapperContainerEl: null,
  systemInfo: null,
  // drawPortsForWidget: () => {},
  // drawVirtualPorts: () => {},
  cleanupAllVirtualPorts: () => {},
  drawPortsAndConnections: () => {},
  removePortsAndConnections: () => {},
  toggleWidgetPortsVisibility: () => {},
  drawingStatus: 'idle',
  setDrawingStatus: () => {},
  getInnerItems: () => ({ widgets: [], virtualPorts: [] }),
  // drawVirtualPortsForWidgets: () => {},
});


interface Props {
  children: React.ReactNode;
}

const LogicMapperContextProvider = LogicMapperContext.Provider;

export const useLogicMapperContext = () => {
  return useContext(LogicMapperContext);
};

export default LogicMapperContextProvider;
